
import { Component, Mixins } from "vue-property-decorator";
import Loading from "@/components/Loading.vue";
import { emptyUserInfo } from "@/types/factoryMethods";
import { getUserInfo } from "@/api";
import { UserInfoEntity } from "@/types/responseEntity";
import { formatDate } from "@/utils/utils";
import VForMixin from "@/mixins/VForMixin";

@Component({
  components: { Loading }
})
export default class UserInfo extends Mixins(Loading, VForMixin) {
  $refs!: { loading: Loading };
  protected render() {
    return (
      <div class="user-info-wrap">
        <loading
          ref="loading"
          onChangeLoadingStatus={this.changeLoadingStatus}
        />
        <div class="user-info" v-show={!this.isLoading}>
          <section>
            <img src={this.userInfo.avatar_url} alt={this.userInfo.loginname} />
            <span class="name">{this.userInfo.loginname}</span>
            <p>积分：{this.userInfo.score}</p>
            <p class="time">
              注册时间：
              {formatDate(this.userInfo.create_at)}
            </p>
          </section>
          <div class="replies">
            <p>回复的主题</p>
            <ul>
              {this.mapListAndReturnElement(this.userInfo.recent_replies)}
            </ul>
          </div>
          <div class="topics">
            <p>创建的主题</p>
            <ul>{this.mapListAndReturnElement(this.userInfo.recent_topics)}</ul>
          </div>
        </div>
      </div>
    );
  }

  private loginName = "";
  private userInfo: UserInfoEntity = emptyUserInfo();

  public mounted() {
    this.loginName = this.$route.params.loginName;
    this.initData();
  }

  public async initData() {
    this.$refs.loading.showLoading();
    this.userInfo = await getUserInfo(this.loginName);
    this.$refs.loading.closeLoading();
  }
}
